module.exports = __webpack_public_path__ + "img/20210320.a5ec59a6.png";